// Routes owned by the Livechat module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const livechatPaths = {
    // Livechat
    livechat: '/livechat',
} as const
